export function evaluatePasswordRequirements(password = "") {
  return {
    minLength: password.length >= 8,
    hasNumber: /\d/.test(password),
    hasSpecial: /[^A-Za-z0-9]/.test(password),
    hasUppercase: /[A-Z]/.test(password),
  };
}

export function passwordRequirementScore(requirements) {
  return Object.values(requirements).filter(Boolean).length;
}

export function passwordMeetsRequirements(requirements) {
  return passwordRequirementScore(requirements) === Object.keys(requirements).length;
}
